<template>
    <div :width="size" :height="size" v-if="type == 'image'" class="logo__wrapper logo--image"  :style="{'max-width': size + 'px', 'max-height': size + 'px', 'min-width': size + 'px', 'width': size + 'px', 'height': size + 'px', 'text-align' : 'center', 'display': 'flex', 'align-items': 'center', 'justify-content': 'center'}">
        <img :src="path" />
    </div>
    <div v-else :width="size" :height="size" class="logo__wrapper logo--icon"  :style="{width: size + 'px', 'min-width': size + 'px', height: size + 'px', padding: Math.ceil(size / 100 * 50 / 2) + 'px'}">
        <div class="icon" :style="{'background-image': getBackgroundImage()}"></div>
    </div>
</template>

<script>
export default {
    name: 'PluginLogo',
    methods: {
        getBackgroundImage() {
            if(this.path) {
                return 'url("https://api.library.loxone.com/files/global/icons/white/' + this.path + '")';
            } else {
                return 'url("https://api.library.loxone.com/files/global/icons/white/icon.svg")';
            }
        }
    },
    props: {
        type: {
            type: String,
            required: true,
        },
        size: {
            type: Number,
            required: true,
        },
        path: {
            type: String,
            required: false,
        },
    },
}
</script>

<style lang="scss" scoped>
    .logo__wrapper{
        box-sizing: border-box;
    }
    .logo--icon{
        background-color:#69c350;

        .icon{
            width: 100%;
            height: 100%;
            background-size: contain;
            background-repeat: no-repeat;
            background-position: center center;
        }
    }
    img{
        max-width: 100%;
        max-height: 100%;
        width: auto;
        height: auto;
    }
</style>
